import { styled } from '@mui/material';

export const ListW = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  @media (max-width: 1023px) {
    row-gap: 8px;
  }
`;
